import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = axios.create({ baseURL: `${BACKEND_URL}/api` });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('plush_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('plush_token');
      localStorage.removeItem('plush_user');
    }
    return Promise.reject(err);
  }
);

export default API;
